<template>
  <v-container fluid class="d-flex justify-center pa-0 flex-wrap container__wrap" fill-height>
    <v-card width="900" class="register_wrap">
      <h1>{{ modify ? '장병 정보 수정' : '장병 등록' }}</h1>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="submit">
          <validation-provider v-slot="{ errors }" name="이름" :rules="{ required: true, checkName: /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z]*$/ }">
            <label>
              장병 이름
              <v-text-field
                v-model="form.solName"
                class="mt-2 mb-4"
                background-color="inputBG"
                outlined
                :error-messages="errors"
                height="48"
                placeholder="이름을 입력하세요."
                dense
                required
                @input="errorMsg = ''"></v-text-field>
            </label>
          </validation-provider>
          <validation-provider v-slot="{ errors }" name="군번" :rules="{ required: true, checkSoldierNumber: /^([0-9]{2})-([0-9]{8})$/ }">
            <label>
              군번
              <v-text-field
                v-model="form.solNumber"
                class="mt-2 mb-4"
                background-color="inputBG"
                outlined
                :error-messages="errors"
                height="48"
                placeholder="군번을 입력하세요."
                dense
                required
                @input="errorMsg = ''"></v-text-field>
            </label>
          </validation-provider>
          <validation-provider v-slot="{ errors }" name="지역구" rules="required" :custom-messages="{ required: '지역구를 선택해주세요.' }">
            <label>
              [행정주소지] 자치구
              <v-select
                v-model="form.corId"
                class="mt-2"
                :items="corpsList"
                item-text="name"
                item-value="id"
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
                background-color="inputBG"
                height="48"
                placeholder="지역구 선택"
                item-color="selectedBlue"
                dense
                required
                outlined
                @input="errorMsg = ''">
                <template #append>
                  <i class="icon select_menu_icon"></i>
                </template>
              </v-select>
            </label>
          </validation-provider>
          <span v-if="errorMsg" class="error--text error_msg">{{ errorMsg }}</span>
          <div class="d-flex justify-end mt-6">
            <v-btn color="primary" class="submit_btn" width="180" height="48" :disabled="invalid" @click="submit">{{ modify ? '정보 수정' : '신규 등록' }}</v-btn>
          </div>
        </form>
      </validation-observer>
    </v-card>
  </v-container>
</template>

<script>
import { regex, required } from 'vee-validate/dist/rules';
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate';
import Api from '@/apis/api';
import router from '@/router';
import { mapState } from 'vuex';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} 필드를 입력해주세요.',
});
extend('checkName', {
  ...regex,
  message: '특수문자, 숫자, 공백을 제외하고 입력해주세요.',
});
extend('checkSoldierNumber', {
  ...regex,
  message: '올바른 군번을 입력해주세요.',
});
export default {
  name: 'Register',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    form: {
      solId: '',
      corId: '',
      solName: '',
      solNumber: '',
    },
    modify: false,
    errorMsg: '',
  }),
  computed: {
    ...mapState('commonValue', ['corpsList']),
  },
  created() {
    if (this.$route.params.id) {
      this.modify = true;
      this.form.solId = parseInt(this.$route.params.id);
      this.getUserInfo(this.form.solId);
    }
  },
  methods: {
    getUserInfo(solId) {
      // Api 호출로 장병데이터 불러오기
      Api.getSoldierInfo({ solId: solId }).then(res => {
        if (res && res.data.rt === 200) {
          // 이미 가입한 장병인 경우 정보 수정 불가
          if (res.data.userId) {
            this.$root.alert.show({
              headerText: '접근 오류',
              content: '잘못된 접근입니다.',
            });
            router.push('/').catch(() => {});
            return false;
          }

          this.form.corId = res.data.corId;
          this.form.solName = res.data.name;
          this.form.solNumber = res.data.number;
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    submit() {
      const request = this.modify ? Api.modifySoldier : Api.createSoldier;

      request(this.form).then(res => {
        if (res && res.data.rt === 200) {
          this.$root.toast.show({
            content: `장병 ${this.modify ? '수정' : '등록'}이 완료되었습니다.`,
          });
          router.push('/user');
        } else {
          if (res.data.rt === 422) {
            this.errorMsg = res.data.rtMsg;
            return;
          }
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
  },
};
</script>

<style scoped></style>
